var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as React from "react";
function SvgDiagramVenn(passedProps, svgRef) {
    var props = __assign({}, passedProps);
    return (React.createElement("svg", __assign({ width: "1.5em", height: "1.5em", viewBox: "0 0 30 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", color: "currentColor", ref: svgRef }, props),
        React.createElement("path", { d: "M12.656 19.969A10.439 10.439 0 019 12c0-3.14 1.406-6 3.656-7.922-.703-.187-1.453-.328-2.156-.328A8.232 8.232 0 002.25 12a8.203 8.203 0 008.25 8.25c.703 0 1.453-.094 2.156-.281zM11.812 15h6.376a11.26 11.26 0 00.515-2.25H11.25c.094.797.281 1.547.563 2.25zm.75 1.5A7.568 7.568 0 0015 18.938a7.913 7.913 0 002.39-2.438h-4.828zm-.75-7.5c-.28.75-.468 1.5-.562 2.25h7.453c-.094-.75-.281-1.5-.515-2.25h-6.375zm5.579-1.5A8.298 8.298 0 0015 5.11a7.913 7.913 0 00-2.438 2.39h4.829zM15 21.516a10.51 10.51 0 01-4.5.984C4.687 22.5 0 17.812 0 12 0 6.234 4.688 1.5 10.5 1.5c1.594 0 3.094.375 4.5 1.031A10.24 10.24 0 0119.5 1.5C25.266 1.5 30 6.234 30 12c0 5.813-4.734 10.5-10.5 10.5-1.64 0-3.14-.328-4.5-.984z", fill: "#242B42" })));
}
var ForwardRef = React.forwardRef(SvgDiagramVenn);
export default ForwardRef;
